// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import {GridList, GridTile} from 'material-ui/GridList';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import EditIcon from 'material-ui/svg-icons/image/edit';
import IconButton from 'material-ui/IconButton';
import Dialog from 'material-ui/Dialog';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

class ViewTournament extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      tournament: {},
      data_uploaded: false,
      data_error: false,
      venues: [],
      game_types: [],
      open: false,
      dialog_open: false,

    };
  }

  handleClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  componentDidMount() {
    this.getTournamentList();
    
  }

  getTournamentList() {
    console.log(this.state.id);
     const url = `${getLocationOrigin()}/eagleeye/${this.state.id}/get_details_tournament/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ tournament: data.tournament}))
       .catch(error => error);
  }


  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.handleCustomerSubmit}
      />,
    ];

    return(
      <div>
        <div className="row" style={{padding: '1%'}}>
          <RaisedButton
            onClick={this.handleClick}
            label="Add"
            style={{float:'right'}}
            secondary={true}
          />
          <Popover
            open={this.state.open}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'left', vertical: 'top'}}
            onRequestClose={this.handleRequestClose}
          >
            <Menu>
              <Link to={`../../crud/addTournamentTeam/${this.state.id}`}><MenuItem primaryText="Add Team" /></Link>
              <Link to={`../../crud/addTournamentFixture/${this.state.id}`}><MenuItem primaryText="Add Fixture" /></Link>
            </Menu>
          </Popover>
        </div>
        <div className="row" style={{padding:'1%'}}>
          <Card>
            <CardHeader
              title={this.state.tournament.name}
              actAsExpander={true}
              showExpandableButton={true}
            />
            <CardText expandable={true}>
                <GridList cols={3} padding={5} cellHeight={'auto'}>
                <ListItem disabled={true} primaryText="Starts On" secondaryText={new Date(this.state.tournament.start_date).toLocaleDateString()}/>
                <ListItem disabled={true} primaryText="No of weeks" secondaryText={this.state.tournament.no_of_weeks}/>
                <ListItem disabled={true} primaryText="Registeration Ends On" secondaryText={new Date(this.state.tournament.registration_end).toLocaleDateString()}/>
                <ListItem disabled={true} primaryText="Venue" secondaryText={this.state.tournament.venue}/>
                <ListItem disabled={true} primaryText="Category" secondaryText={this.state.tournament.category + ':' +
                this.state.tournament.sub_category}/>
              </GridList>
            </CardText>
            <CardMedia
              overlay={<CardTitle title={this.state.tournament.name}/>}
            >
              <img style={{height:'60vh'}} src={this.state.tournament.banner==null?'http://www.sporthood.in/assets/img/avatar.png':
              `https://api.sporthood.in/${this.state.tournament.banner}`} alt="" />
            </CardMedia>
          </Card>
        </div>

        <div className="row" style={{padding:'1%'}}>

          <div className="col-md-4" style={{padding:'1%'}}>
            <Card style={{backgroundColor:'rgb(171, 71, 188)'}}>
              <CardHeader
                title="STANDINGS"
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText expandable={true}>
                <Table>
                  <TableHeader displaySelectAll={false}>
                    <TableRow>
                      <TableHeaderColumn>Name</TableHeaderColumn>
                      <TableHeaderColumn>Points</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                    {this.state.tournament.standing?this.state.tournament.standing.map((x,index) => (
                      <TableRow key={x.P+x.team}>
                        <TableRowColumn>{x.team}</TableRowColumn>
                        <TableRowColumn>{x.P}</TableRowColumn>
                      </TableRow>
                    )):''}
                  </TableBody>
                </Table>
              </CardText>
            </Card>
          </div>

          <div className="col-md-4" style={{padding:'1%'}}>
            <Card style={{backgroundColor:'rgb(171, 71, 188)'}}>
              <CardHeader
                title="TOP SCORERS"
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText expandable={true}>
                <Table>
                  <TableHeader displaySelectAll={false}>
                    <TableRow>
                      <TableHeaderColumn>Name</TableHeaderColumn>
                      <TableHeaderColumn>Team</TableHeaderColumn>
                      <TableHeaderColumn>Goals</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                    {this.state.tournament.top_scorers?this.state.tournament.top_scorers.slice(0,9).map((x,index) => (
                      <TableRow key={x.customer_id}>
                        <TableRowColumn>{x.Name}</TableRowColumn>
                        <TableRowColumn>{x.Team}</TableRowColumn>
                        <TableRowColumn>{x.Goals}</TableRowColumn>
                      </TableRow>
                    )):''}
                  </TableBody>
                </Table>
              </CardText>
            </Card>
          </div>

          <div className="col-md-4" style={{padding:'1%'}}>
            <Card style={{backgroundColor:'rgb(171, 71, 188)'}}>
              <CardHeader
                title="TOP ASSISTS"
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText expandable={true}>
                <Table>
                  <TableHeader displaySelectAll={false}>
                    <TableRow>
                      <TableHeaderColumn>Name</TableHeaderColumn>
                      <TableHeaderColumn>Team</TableHeaderColumn>
                      <TableHeaderColumn>Assists</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                    {this.state.tournament.top_assists?this.state.tournament.top_assists.slice(0,9).map((x,index) => (
                      <TableRow key={`a${x.customer_id}`}>
                        <TableRowColumn>{x.Name}</TableRowColumn>
                        <TableRowColumn>{x.Team}</TableRowColumn>
                        <TableRowColumn>{x.Assists}</TableRowColumn>
                      </TableRow>
                    )):''}
                  </TableBody>
                </Table>
              </CardText>
            </Card>
          </div>
        </div>

        <div className="row">
          {this.state.tournament.tournament_teams?
            this.state.tournament.tournament_teams.map((x, index) => (
            <div className="col-md-12" style={{paddingBottom: '1%'}}>
              <Card key={x.id}>
                <CardHeader
                  title={x.name}
                  actAsExpander={true}
                  showExpandableButton={true}
                  avatar={`https://api.sporthood.in/${x.logo}`}
                />
                <div style={{display:'flex', justifyContent: 'space-between'}}>
                  <div style={{display:'flex'}}>
                    <CardText>Total Collection: Rs {x.amount_paid.amount__sum}</CardText>
                    <CardText>Members: {x.count}</CardText>
                  </div>
                  <div style={{flexDirection: 'row', justifyContent: 'space-between', padding: '1px'}}>
                  <Link to={`../../crud/deleteTeam/${this.state.id}/${x.id}/`}>
                      <FlatButton
                        backgroundColor="#ec407f"
                        label="Delete Team"
                        style={{float:'right', marginLeft: '5px'}}
                      />
                    </Link>
                    <Link to={`../../crud/addTournamentTeamMember/${this.state.id}/${x.id}/${x.name}`}>
                      <FlatButton
                        backgroundColor="#c6ff00"
                        label="Add Players"
                        style={{float:'right'}}
                      />
                    </Link>
                  </div>
                </div>
                <CardText expandable={true}>
                  <GridList cols={3} padding={8}>
                    {x.tournament_members?x.tournament_members.map((y, index) => (
                        <Card style={{backgroundColor:'#BDBDBD'}} key={y.photo+y.name}>
                          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '9px 8px'}}>
                            <CardHeader
                              title={y.name + '-' + y.mobile_no}
                              avatar={y.photo=='http://www.sporthood.in/assets/img/avatar.png'?y.photo:
                              `https://api.sporthood.in/${y.photo}`}
                              style={{padding: '0px !important'}}
                            />
                            <IconButton href={`../../#/crud/editTournamentSubscription/${y.subscription.id}/${y.subscription.amount}`}>
                              <EditIcon style={{float: 'right'}}/>
                            </IconButton>
                            <IconButton href={`../../#/crud/deleteTeammember/${y.id}`}>
                              <DeleteIcon style={{float: 'right'}}/>
                            </IconButton>
                          </div>
                          <CardText>Amount Paid: {y.subscription.amount}</CardText>
                          <CardText>Package: {y.subscription.package}</CardText>
                        </Card>
                    )):''}
                  </GridList>
                </CardText>
              </Card>
            </div>
          ))
          :''}
        </div>

        <div className="row" style={{paddingTop:'3%'}}>
          {this.state.tournament.matches?
            <GridList cols={3} padding={10} cellHeight={'auto'}>
              {this.state.tournament.matches.map((x, index) => (
                <Card style={{backgroundColor:'#FFEB3B'}} key={index}>
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '8px 4px'}}>
                    <CardHeader
                      title={new Date(x.session_start).toLocaleDateString()}
                      titleStyle={{fontSize: 20}}
                      style={{padding: '0px !important', marginTop: '8px'}}
                    />
                    <IconButton href={`../../#/crud/editMatch/${x.fixture_id}`}>
                      <EditIcon/>
                    </IconButton>
                    <IconButton href={`../../#/crud/deleteMatch/${x.id}`}>
                      <DeleteIcon style={{float: 'right'}}/>
                    </IconButton>
                  </div>
                  <Card key={x.fixture_session+x.team_one.name}>
                    <CardHeader
                      title={x.team_one.name + ' : ' + x.team_one.score}
                      avatar={`https://api.sporthood.in/${x.team_one.logo}`}
                    />
                  </Card>
                  <Card key={x.fixture_session+x.team_two.name}>
                    <CardHeader
                      title={x.team_two.name + ' : ' + x.team_two.score}
                      avatar={`https://api.sporthood.in/${x.team_two.logo}`}
                    />
                  </Card>
              </Card>
          ))}
          </GridList>
          :''}
        </div>
      </div>
    );
  }
}

export default ViewTournament;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewTournament/index.js